import { render, staticRenderFns } from "./apiInfo.vue?vue&type=template&id=274e213e&scoped=true"
import script from "./apiInfo.vue?vue&type=script&lang=js"
export * from "./apiInfo.vue?vue&type=script&lang=js"
import style0 from "./apiInfo.vue?vue&type=style&index=0&id=274e213e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e213e",
  null
  
)

export default component.exports